function Poster(params) {
    let { link } = params;
    if (!link || link.length === 0) link = "https://via.placeholder.com/300x450";

    return (
        <div style={{
            width: '100%',
            borderRadius: '12px',
            overflow: 'hidden',
            backgroundColor: 'transparent',
        }}>
            <img
                src={link}
                alt="poster"
                style={{
                    width: '100%',
                    height: 'auto',
                    display: 'block',
                    borderRadius: '12px',
                }}
            />
        </div>
    );
}

export default Poster;